import { VideoSecWrapper } from "../../styles/StyledComponents/VideoSecWrapper";
import Fancybox from "../../ui/FancyBox/FancyBox";
import assests from "../../ui/assests";
import PlayIcon from "../../ui/icons/PlayIcon";

const VideoSec = () => {
  return (
    <VideoSecWrapper className="cmn_gap_btm">
      <div className="container">
        <div className="video_play_box">
          <figure>
            <img src={assests.videobg} alt="" />
          </figure>
          <Fancybox
            options={{
              Carousel: {
                infinite: false,
              },
            }}
          >
            <a
              data-fancybox
              href="https://www.youtube.com/watch?v=q0WeC0HaqD4"
              className="playBtn_icon"
            >
              <PlayIcon />
            </a>
          </Fancybox>
        </div>
      </div>
    </VideoSecWrapper>
  );
};

export default VideoSec;
